import { registerLocaleData } from '@angular/common';

import localeFr from '@angular/common/locales/fr';
import localeBe from '@angular/common/locales/fr-BE';
import localeAt from '@angular/common/locales/de-AT';
import localeCz from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeHu from '@angular/common/locales/hu';
import localeIe from '@angular/common/locales/en-IE';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeUk from '@angular/common/locales/en-GB';
import localeAe from '@angular/common/locales/ar-AE';
import localeCh from '@angular/common/locales/fr-CH';
import localeEg from '@angular/common/locales/ar-EG';
import localeGr from '@angular/common/locales/el';
import localeBg from '@angular/common/locales/bg';

export function registerAllLocales(): void {
  registerLocaleData(localeFr, 'fr');
  registerLocaleData(localeBe, 'fr-BE');
  registerLocaleData(localeAt, 'de-AT');
  registerLocaleData(localeCz, 'cs');
  registerLocaleData(localeDe, 'de');
  registerLocaleData(localeEs, 'es');
  registerLocaleData(localeHu, 'hu');
  registerLocaleData(localeIe, 'en-IE');
  registerLocaleData(localeIt, 'it');
  registerLocaleData(localeNl, 'nl');
  registerLocaleData(localePl, 'pl');
  registerLocaleData(localePt, 'pt');
  registerLocaleData(localeRu, 'ru');
  registerLocaleData(localeSk, 'sk');
  registerLocaleData(localeUk, 'en-GB');
  registerLocaleData(localeAe, 'ar-AE');
  registerLocaleData(localeCh, 'fr-CH');
  registerLocaleData(localeEg, 'ar-EG');
  registerLocaleData(localeGr, 'el');
  registerLocaleData(localeBg, 'bg');
}
